import type { FastifyInstance } from 'fastify'
import { BillingController } from './billing.controller.js'
import { authMiddleware } from '../../middleware/auth.middleware.js'

export async function billingRoutes(
  fastify: FastifyInstance,
  controller: BillingController
) {
  fastify.get('/plans', {
    handler: controller.listPlans.bind(controller)
  })

  fastify.route({
    method: 'GET',
    url: '/subscription',
    preHandler: authMiddleware,
    handler: controller.getSubscription.bind(controller)
  })

  fastify.route({
    method: 'GET',
    url: '/usage',
    preHandler: authMiddleware,
    handler: controller.getQuotaUsage.bind(controller)
  })

  fastify.route({
    method: 'POST',
    url: '/checkout',
    preHandler: authMiddleware,
    handler: controller.createCheckoutSession.bind(controller)
  })

  fastify.route({
    method: 'POST',
    url: '/portal',
    preHandler: authMiddleware,
    handler: controller.createBillingPortalSession.bind(controller)
  })

  // Webhook endpoint - needs raw body for Stripe signature verification
  fastify.route({
    method: 'POST',
    url: '/webhook',
    config: { rawBody: true } as any,
    handler: controller.handleWebhook.bind(controller)
  })

  fastify.route({
    method: 'POST',
    url: '/referrals/generate',
    preHandler: authMiddleware,
    handler: controller.generateReferralCode.bind(controller)
  })

  fastify.get('/referrals/leaderboard', {
    handler: controller.referralLeaderboard.bind(controller)
  })

  // Admin routes
  fastify.route({
    method: 'GET',
    url: '/admin/plans',
    preHandler: authMiddleware,
    handler: controller.adminListPlans.bind(controller)
  })

  fastify.route({
    method: 'POST',
    url: '/admin/plans',
    preHandler: authMiddleware,
    handler: controller.adminCreatePlan.bind(controller)
  })

  fastify.route<{ Params: { id: string } }>({
    method: 'PUT',
    url: '/admin/plans/:id',
    preHandler: authMiddleware,
    handler: controller.updatePlan.bind(controller)
  })

  fastify.route<{ Params: { id: string } }>({
    method: 'DELETE',
    url: '/admin/plans/:id',
    preHandler: authMiddleware,
    handler: controller.deletePlan.bind(controller)
  })

  fastify.route({
    method: 'GET',
    url: '/admin/metrics',
    preHandler: authMiddleware,
    handler: controller.adminMetrics.bind(controller)
  })
}
